import { APIRequest, APIRequestDtoImpl } from '../apiRequest';
import { SubscriberValidationDto } from '../../dto/subscribervalidation/subscribervalidationdto';


export interface SubscriberValidationRequest extends APIRequest
{
    getSubscriberValidationRequest(): SubscriberValidationDto;
}

export class SubscriberValidationRequestImpl extends APIRequestDtoImpl implements SubscriberValidationRequest
{
    constructor(private subscriberValidationData: SubscriberValidationDto)
    {
        super();
    }

    getSubscriberValidationRequest(): SubscriberValidationDto
    {
        return this.subscriberValidationData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationrequest.tsx